import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { storeToRefs } from "pinia";
import { TRANSACTION_TYPES } from "@/utils/constants";
import { useTransactionConfirmModal } from "@/stores/transactionConfirmModal";

import DefaultTransactionConfirm from "./TransactionConfirmContent/DefaultTransactionConfirm.vue";
import TradeTransactionConfirm from "./TransactionConfirmContent/TradeTransactionConfirm.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TransactionConfirmDialog',
  setup(__props) {

const { modalData } = storeToRefs(useTransactionConfirmModal());

return (_ctx: any,_cache: any) => {
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _unref(modalData).isOpen,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(modalData).isOpen) = $event)),
    persistent: "",
    "max-width": "460",
    class: "transaction-confirm-dialog"
  }, {
    default: _withCtx(() => [
      (_unref(modalData).transactionType === _unref(TRANSACTION_TYPES).TRADE)
        ? (_openBlock(), _createBlock(TradeTransactionConfirm, { key: 0 }))
        : (_openBlock(), _createBlock(DefaultTransactionConfirm, { key: 1 }))
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})